// extracted by mini-css-extract-plugin
export default {"container":"_1K5rn","triangleBorder":"_1P2iC","defaultColor":"_3AQ1T","triangleBackground":"_21wPV"};